module.exports = __webpack_public_path__ + "img/icn-walletauto.693af12d.svg";